import { createRoot } from "react-dom/client";
import { captureUtmParams } from "./lib/analytics";
import App from "./App.tsx";
import "./index.css";

// Capture UTM params from URL before React renders
captureUtmParams();

createRoot(document.getElementById("root")!).render(<App />);
